export const downloadFromABlob = (blob, fileName = 'file', fileExtension = 'pdf') => {
  const objectURL = URL.createObjectURL(blob);
  const anchorElement = document.createElement('a');
  anchorElement.href = objectURL;
  anchorElement.download = `${fileName}.${fileExtension}`;
  anchorElement.click();
};
